module.exports = __webpack_public_path__ + "static/img/zwyth_05.6d08d0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/zwyth_05.png
// module id = ngBl
// module chunks = 1